import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// All requests send cookies automatically (httpOnly auth cookie)
axios.defaults.withCredentials = true;

// Universities
export const getUniversities = async (params = {}) => {
  const response = await axios.get(`${API}/universities`, { params });
  return response.data;
};

export const getUniversity = async (id) => {
  const response = await axios.get(`${API}/universities/${id}`);
  return response.data;
};

export const createUniversity = async (data) => {
  const response = await axios.post(`${API}/universities`, data);
  return response.data;
};

export const updateUniversity = async (id, data) => {
  const response = await axios.put(`${API}/universities/${id}`, data);
  return response.data;
};

// Courses
export const getCourses = async (params = {}) => {
  const response = await axios.get(`${API}/courses`, { params });
  return response.data;
};

export const getCourse = async (id) => {
  const response = await axios.get(`${API}/courses/${id}`);
  return response.data;
};

export const createCourse = async (data) => {
  const response = await axios.post(`${API}/courses`, data);
  return response.data;
};

// Students
export const getStudents = async () => {
  const response = await axios.get(`${API}/students`);
  return response.data;
};

export const getStudent = async (id) => {
  const response = await axios.get(`${API}/students/${id}`);
  return response.data;
};

export const createStudent = async (data) => {
  const response = await axios.post(`${API}/students`, data);
  return response.data;
};

export const updateStudent = async (id, data) => {
  const response = await axios.put(`${API}/students/${id}`, data);
  return response.data;
};

// Applications
export const getApplications = async (params = {}) => {
  const response = await axios.get(`${API}/applications`, { params });
  return response.data;
};

export const getApplication = async (id) => {
  const response = await axios.get(`${API}/applications/${id}`);
  return response.data;
};

export const createApplication = async (data) => {
  const response = await axios.post(`${API}/applications`, data);
  return response.data;
};

export const updateApplicationStatus = async (id, status, note = null) => {
  const response = await axios.put(
    `${API}/applications/${id}/status`,
    null,
    { params: { status, note } }
  );
  return response.data;
};

// Documents
export const uploadDocument = async (studentId, documentType, file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await axios.post(
    `${API}/documents/upload`,
    formData,
    {
      params: { student_id: studentId, document_type: documentType },
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return response.data;
};

export const getStudentDocuments = async (studentId) => {
  const response = await axios.get(`${API}/documents/student/${studentId}`);
  return response.data;
};

export const downloadDocument = async (docId) => {
  const response = await axios.get(`${API}/documents/${docId}/download`, {
    responseType: 'blob'
  });
  return response.data;
};

export const verifyDocument = async (docId) => {
  const response = await axios.put(`${API}/documents/${docId}/verify`);
  return response.data;
};

// Commissions
export const getCommissions = async (params = {}) => {
  const response = await axios.get(`${API}/commissions`, { params });
  return response.data;
};

export const createCommission = async (data) => {
  const response = await axios.post(`${API}/commissions`, data);
  return response.data;
};

export const updateCommissionStatus = async (id, status) => {
  const response = await axios.put(
    `${API}/commissions/${id}/status`,
    null,
    { params: { status } }
  );
  return response.data;
};

// Eligibility Check
export const checkEligibility = async (studentId, courseId) => {
  const response = await axios.post(
    `${API}/eligibility-check`,
    { student_id: studentId, course_id: courseId }
  );
  return response.data;
};

export const quickEligibilityCheck = async (data) => {
  const response = await axios.post(
    `${API}/eligibility-check/quick`,
    data
  );
  return response.data;
};

// Analytics
export const getDashboardAnalytics = async () => {
  const response = await axios.get(`${API}/analytics/dashboard`);
  return response.data;
};

export const getMarketInsights = async () => {
  const response = await axios.get(`${API}/analytics/market-insights`);
  return response.data;
};

// Users (Admin)
export const getUsers = async (role = null) => {
  const response = await axios.get(`${API}/users`, { params: { role } });
  return response.data;
};

export const getPendingUsers = async () => {
  const response = await axios.get(`${API}/users/pending`);
  return response.data;
};

export const approveUser = async (userId) => {
  const response = await axios.put(`${API}/users/${userId}/approve`);
  return response.data;
};

export const rejectUser = async (userId) => {
  const response = await axios.put(`${API}/users/${userId}/reject`);
  return response.data;
};

export const updateUserStatus = async (userId, isActive) => {
  const response = await axios.put(
    `${API}/users/${userId}/status`,
    null,
    { params: { is_active: isActive } }
  );
  return response.data;
};

// Seed Demo Data
export const seedDemoData = async () => {
  const response = await axios.post(`${API}/seed-demo-data`);
  return response.data;
};

// Public Stats
export const getActiveAgentsCount = async () => {
  const response = await axios.get(`${API}/stats/active-agents-count`);
  return response.data;
};

// Canada Colleges
export const getCanadaColleges = async (params = {}) => {
  const response = await axios.get(`${API}/canada-colleges`, { params });
  return response.data;
};

export const getCanadaProvinces = async () => {
  const response = await axios.get(`${API}/canada-colleges/provinces`);
  return response.data;
};

export const submitContactForm = async (data) => {
  const response = await axios.post(`${API}/contact`, data);
  return response.data;
};

export { API, BACKEND_URL };
